import { AcademyCourse } from '../../models/academy-course.model';
import { chatMessagesCourse } from './chat-messages-course.constants';
import { didacticsCourse } from './didactics-course.constants';
import { lessonspaceCourse } from './lessonspace-course.constants';
import { moreRequestsCourse } from './more-requests-course.constants';
import { rulesCourse } from './rules-course.constants';
import { trialLessonCourse } from './trial-lesson-course.constants';

export const academyCourses: Array<AcademyCourse> = [
  rulesCourse,
  moreRequestsCourse,
  trialLessonCourse,
  chatMessagesCourse,
  lessonspaceCourse,
  didacticsCourse
];
